import { BaseRoute, OutletRoute, RouteObject } from 'types';

const batchCollection = '/coleta-de-pedidos';
const confirmCollect = `${batchCollection}/registro-da-coleta`;

export const routes: Record<BaseRoute, RouteObject> = {
  dashboard: { path: '/', name: 'Home' },
  returnsAndRefunds: {
    path: '/devolucoes-e-estornos',
    name: 'Devoluções e estornos',
  },
  pixTransactionsReport: {
    path: '/relatorio-transacoes-financeiras',
    name: 'Relatório de transações Pix',
  },
  performance: { path: '/performance', name: 'Performance de Atendimento' },
  financialTransactions: {
    path: '/transacoes-financeiras',
    name: 'Transações financeiras',
  },
  openingDays: {
    path: '/horarios-de-atendimento',
    name: 'Horários de atendimento',
  },
  profile: { path: '/perfil', name: 'Perfil da Loja' },
  batchCollection: {
    path: batchCollection,
    name: 'Coleta de pedidos',
  },
  confirmCollect: { path: confirmCollect, name: 'Registro da coleta' },
  ordersCodeList: {
    path: `${confirmCollect}/lista-de-coleta`,
    name: 'Lista de coleta',
  },
  exchangeAndReturn: {
    path: '/trocas-e-devolucoes',
    name: 'Devoluções',
  },
  exchangeReturnForm: {
    path: '/trocas-e-devolucoes/formulario-de-atendimento',
    name: 'Trocas e formulário',
  },
  login: { path: '/login', name: 'Login' },
  resetPassword: { path: '/login/password-reset', name: 'Redefinir senha' },
  scoreReport: { path: '/nivel-de-atendimento', name: 'Nível de atendimento' },
  pickingManagement: {
    path: '/separacao-de-produtos',
    name: 'Separação de produtos',
  },
  regulatoryInformation: {
    path: '/informacoes-regulatorias',
    name: 'Informações Regulatórias',
  },
  discount: {
    path: '/descontos',
    name: 'Descontos por Coleção',
  },
};

export const outletRoutes: Record<OutletRoute, RouteObject> = {
  selectReturn: {
    path: 'selecionar-produtos',
    name: 'Selecionar produtos',
  },
  details: {
    path: 'detalhes',
    name: 'Detalhes',
  },
  stepCreated: {
    path: 'step-devolucao-criada',
    name: 'Devolução criada',
  },
  stepPost: {
    path: 'step-postagem',
    name: 'Postagem da devolução',
  },
  stepReceived: {
    path: 'step-recebido',
    name: 'Devolução recebida',
  },
  stepCompleted: {
    path: 'completo',
    name: 'Devolução completa',
  },
  stepCancelled: {
    path: 'cancelado',
    name: 'Devolução cancelada',
  },
};
